var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 24,
    rx: 2,
    fill: "white",
    stroke: "#DBE0E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3356 18.2773C16.962 19.4277 15.1801 20.1222 13.2331 20.1222C8.8886 20.1222 5.3667 16.6644 5.3667 12.399C5.3667 8.13359 8.8886 4.67578 13.2331 4.67578C15.1801 4.67578 16.962 5.3703 18.3356 6.52077C19.7093 5.3703 21.4911 4.67579 23.4381 4.67579C27.7826 4.67579 31.3045 8.13359 31.3045 12.399C31.3045 16.6644 27.7826 20.1222 23.4381 20.1222C21.4911 20.1222 19.7092 19.4277 18.3356 18.2773Z",
    fill: "#E22837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3354 18.2773C20.0268 16.8607 21.0993 14.7528 21.0993 12.399C21.0993 10.0452 20.0268 7.93734 18.3354 6.52076C19.7091 5.37029 21.4909 4.67578 23.438 4.67578C27.7825 4.67578 31.3044 8.13359 31.3044 12.399C31.3044 16.6644 27.7825 20.1222 23.438 20.1222C21.4909 20.1222 19.7091 19.4277 18.3354 18.2773Z",
    fill: "#FA7E46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3356 18.2769C20.0269 16.8603 21.0994 14.7525 21.0994 12.3987C21.0994 10.0449 20.0269 7.93709 18.3356 6.52051C16.6442 7.93709 15.5718 10.0449 15.5718 12.3987C15.5718 14.7525 16.6442 16.8603 18.3356 18.2769Z",
    fill: "#FF5E00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMasterCard);
export default __webpack_public_path__ + "static/media/ico_masterCard.47073a84d033eaf3a29c19cfd0aea357.svg";
export { ForwardRef as ReactComponent };